if(objects.is_single){
 
    let swiper_aventure_haut = new Swiper('.swiper-container-aventure-haut', {
        slidesPerView: 2,
        spaceBetween: 0,
        slidesPerColumnFill: 'column',
        grabCursor: true,
        loop: true,
        breakpoints: {
            576:{
            spaceBetween: 0,
            slidesPerView: 3,
            },
            1400:{
            spaceBetween: 0,
            slidesPerView: 4,
            },
            1600:{
            spaceBetween: 0,
            slidesPerView: 5,
            }
        },
        });
    
        let swiper_aventure_bas  = new Swiper('.swiper-container-aventure-bas', {
        slidesPerView: 2,
        spaceBetween: 0,
        slidesPerColumnFill: 'column',
        grabCursor: true,
        loop: true,
        breakpoints: {
            576:{
            spaceBetween: 0,
            slidesPerView: 3,
            },
            1400:{
            spaceBetween: 0,
            slidesPerView: 4,
            },
            1600:{
            spaceBetween: 0,
            slidesPerView: 5,
            }
        },
    });

    let price = document.querySelector(".box-middle .price")
    const selecteur = document.querySelector(".selecteur-wrap")
    const button_minus = document.querySelector(".selecteur-wrap .selecteur-bouton.moins")
    const button_plus = document.querySelector(".selecteur-wrap .selecteur-bouton.plus")
    const players = document.querySelector(".selecteur-wrap .selecteur-bouton.nombre")
    const players_max = players.getAttribute('data-max');
    const players_min = players.getAttribute('data-min');
    let nombre = parseInt(players.innerHTML)

    function cursor() {
        if (nombre <= players_min ) {
            button_minus.style.cursor = "default"
        } else if (nombre >= players_max){
            button_plus.style.cursor = "default"
        } else {
            button_minus.style.cursor = "pointer"
            button_plus.style.cursor = "pointer"
        }

        var current_wrapper_all = selecteur.nextElementSibling
        var current_wrapper = current_wrapper_all.querySelector(".wrapper[for='price-" + nombre + "']")
        var current_wrappers = current_wrapper_all.querySelectorAll(".wrapper")
        current_wrappers.forEach(function(wrapper) {
            wrapper.style.display = 'none'
        })
        current_wrapper.style.display = 'flex'
    }

    function calcul() {
        players.innerHTML = nombre

        // switch (nombre) {
        // case 3:
        //     price.innerHTML = 35
        //     break;
        // case 4:
        //     price.innerHTML = 30
        //     break;
        // case 5:
        //     price.innerHTML = 27
        //     break;
        // default:
        //     price.innerHTML = 24
        //     break;
        // }
    }

    button_minus.addEventListener('click', () => {
        if (nombre > players_min ) {
          nombre -= 1
        }
        cursor()
        calcul()
      })
      button_plus.addEventListener('click', () => {
        if (nombre < players_max ) {
          nombre -= -1
        }
        cursor()
        calcul()
      })

    cursor()
    calcul()
}